export const CHRYSCAPITAL_COMPANIES = [
  {
    id: "resultscx",
    name: "ResultsCX",
    sector: "Business Process Services",
    headcount: 20000,
    asbc_gap: 580000000,
    labour_cost: 2800000000,
    currency: "INR",
    demo_url: "https://app.reaimagination.com/demo/resultscx-chryscapital-2026",
    signal: "red",
    urgency_reason: "Customer support automation risk at critical threshold",
    functions: ["Customer Operations", "Technical Support", "Healthcare Services", "Quality Assurance", "Technology", "HR & People"],
    competitors: [
      { name: "ResultsCX", score: 32, isTarget: true },
      { name: "Concentrix", score: 71 },
      { name: "Teleperformance", score: 68 },
      { name: "TaskUs", score: 79 },
      { name: "EXL Service", score: 61 },
    ],
    velocity_headline: "AI-native BPO competitors restructuring at 2.4\u00d7 velocity",
    leadership_scores: [6, 7, 5, 4, 5, 6, 6],
    readiness_score: 68,
    readiness_drivers: [
      "Customer support roles at 74% AI addressability \u2014 immediate risk",
      "AI-native competitors (TaskUs) restructuring workforce faster",
      "Digital & AI capability gap at leadership level",
    ],
  },
  {
    id: "quest-global",
    name: "Quest Global",
    sector: "Engineering Services",
    headcount: 11000,
    asbc_gap: 320000000,
    labour_cost: 1650000000,
    currency: "INR",
    demo_url: "https://app.reaimagination.com/demo/quest-global-chryscapital-2026",
    signal: "red",
    urgency_reason: "Engineering services AI disruption accelerating globally",
    functions: ["Mechanical Engineering", "Software Engineering", "Digital Engineering", "Aerospace & Defence", "Quality & Testing", "HR & People"],
    competitors: [
      { name: "Quest Global", score: 41, isTarget: true },
      { name: "LTTS", score: 67 },
      { name: "Tata Technologies", score: 63 },
      { name: "Cyient", score: 58 },
      { name: "Expleo", score: 72 },
    ],
    velocity_headline: "Engineering services peers adopting AI tools 1.8\u00d7 faster",
    leadership_scores: [7, 6, 6, 5, 6, 7, 7],
    readiness_score: 59,
    readiness_drivers: [
      "Engineering automation tools displacing manual design work",
      "Digital engineering capability lagging LTTS benchmark",
      "Global delivery model needs AI-first redesign",
    ],
  },
  {
    id: "lenskart",
    name: "Lenskart",
    sector: "Omnichannel Retail",
    headcount: 8000,
    asbc_gap: 195000000,
    labour_cost: 960000000,
    currency: "INR",
    demo_url: "https://app.reaimagination.com/demo/lenskart-chryscapital-2026",
    signal: "amber",
    urgency_reason: "Rapid global expansion creating workforce architecture gaps",
    functions: ["Retail Operations", "Customer Experience", "Technology & Product", "Supply Chain", "Marketing", "HR & People"],
    competitors: [
      { name: "Lenskart", score: 52, isTarget: true },
      { name: "EssilorLuxottica", score: 74 },
      { name: "GrandVision", score: 61 },
      { name: "Specsavers", score: 58 },
      { name: "Titan Eye Plus", score: 49 },
    ],
    velocity_headline: "Global eyewear peers restructuring retail ops 1.4\u00d7 faster",
    leadership_scores: [8, 5, 8, 7, 6, 7, 7],
    readiness_score: 48,
    readiness_drivers: [
      "2,000 store retail ops at high automation potential",
      "International expansion outpacing org design capability",
      "Strong leadership composite \u2014 ready to accelerate",
    ],
  },
  {
    id: "hdfc-credila",
    name: "HDFC Credila",
    sector: "Education Finance",
    headcount: 3500,
    asbc_gap: 125000000,
    labour_cost: 680000000,
    currency: "INR",
    demo_url: "https://app.reaimagination.com/demo/hdfc-credila-chryscapital-2026",
    signal: "amber",
    urgency_reason: "Education lending field force redesign opportunity",
    functions: ["Credit & Underwriting", "Field Sales", "Operations & Processing", "Technology", "Risk & Compliance", "HR & People"],
    competitors: [
      { name: "HDFC Credila", score: 48, isTarget: true },
      { name: "Avanse Financial", score: 62 },
      { name: "InCred Finance", score: 71 },
      { name: "Auxilo Finance", score: 58 },
      { name: "IDFC First Bank Edu", score: 55 },
    ],
    velocity_headline: "Fintech education lenders restructuring field force faster",
    leadership_scores: [6, 7, 5, 6, 5, 6, 6],
    readiness_score: 52,
    readiness_drivers: [
      "Field sales force at significant automation risk",
      "Credit underwriting AI adoption below sector peers",
      "Post-acquisition integration creates workforce redesign window",
    ],
  },
  {
    id: "wow-skin",
    name: "WOW Skin Science",
    sector: "D2C Consumer Beauty",
    headcount: 2500,
    asbc_gap: 88000000,
    labour_cost: 420000000,
    currency: "INR",
    demo_url: "https://app.reaimagination.com/demo/wow-skin-chryscapital-2026",
    signal: "green",
    urgency_reason: "Strong digital foundation — optimise for next growth phase",
    functions: ["Marketing & Brand", "E-Commerce Operations", "Supply Chain", "Product Development", "Customer Experience", "HR & People"],
    competitors: [
      { name: "WOW Skin Science", score: 61, isTarget: true },
      { name: "Mamaearth", score: 69 },
      { name: "Plum", score: 64 },
      { name: "mCaffeine", score: 58 },
      { name: "The Derma Co", score: 66 },
    ],
    velocity_headline: "D2C beauty peers building AI-driven personalisation faster",
    leadership_scores: [7, 6, 7, 7, 6, 7, 7],
    readiness_score: 39,
    readiness_drivers: [
      "Digital-first model well-positioned for AI optimisation",
      "Marketing automation opportunity in customer acquisition",
      "Leadership composite 6.7/10 \u2014 strong transformation capacity",
    ],
  },
];
